import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Layout from 'components/Layout';
import PageContainer from 'components/PageContainer';
import PageTitle from 'components/PageTitle';
import Markup from 'components/Markup';
import Adwords from 'components/Adwords';
import prismic from '../prismic';
import { fetchContact } from 'actions/prismic';

class Contact extends Component {
  static async getInitialProps({ store, req, lang, prismicRef }) {
    return store.dispatch(fetchContact({ lang, prismicRef }));
  }

  render() {
    const { contact, ...rest } = this.props;
    const { body, meta, ...other } = prismic.contact(contact);
    return (
      <Layout {...rest} {...other} meta={meta}>
        <Adwords />
        <PageContainer>
          <PageTitle>{meta.title}</PageTitle>
          <div className="container">
            <div className="row">
              <div className="col-sm-6 px-4 px-sm-0">
                <Markup>{body}</Markup>
              </div>
              <div className="col-md-6">
                <div className="embed-responsive embed-responsive-16by9">
                  <iframe
                    className="embed-responsive-item"
                    style={{ border: 0, width: '100%' }}
                    src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d2435.2396605837826!2d4.900625!3d52.3842056!3m2!1i1024!2i768!4f13.1!3m2!1m1!2sQuestionmark!5e0!3m2!1sen!2snl!4v1589287001500!5m2!1sen!2snl"
                    height="500"
                    allowFullScreen="allowfullscreen"
                  />
                </div>
              </div>
            </div>
          </div>
        </PageContainer>
      </Layout>
    );
  }
}

Contact.propTypes = {
  contact: PropTypes.object
};

export default connect(({ prismic }) => ({
  contact: prismic.contact
}))(Contact);
